import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation, ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import { 
  REFRESH_TOKEN_MUTATION,
  CHANGE_PASSWORD_MUTATION,
  CHANGE_EMAIL_MUTATION
} from "../../graphQL/user_qry";

import { 
  Container, 
  Card, 
  CardContent, 
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  FormHelperText, 
  makeStyles 
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { Tabs, Tab } from "@mui/material";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import { project_url } from "../../constants/Data";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.2rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
}));

const ApplicantProfile = () => {
  const classes = useStyles();

  const [errorMsg, setErrorMsg] = useState({
    newPassword: "", 
    confirmNewPassword: "",
    samePasswords: "",
    email: "",
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      email: "",
    }
  });

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [alertMsg, setAlertMsg] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);

  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);    
  };

  const handleToggleRepeatPassword = () => {
    setShowRepeatPassword((prev) => !prev);    
  };

  const [originalEmail, setOriginalEmail] = useState(
    localStorage.getItem("email") ? 
    localStorage.getItem("email") : 
    null
  );
  const [email, setEmail] = useState("");
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else navigate(`${project_url}/signin/?next=${pathname}`);
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  let applicantId = 0;
  if(localStorage.getItem("applicantId"))
    applicantId = localStorage.getItem("applicantId");

  useEffect(() => {
    const storedEmail = localStorage.getItem("email") ? 
      localStorage.getItem("email") 
      : null;
    setEmail(storedEmail);
    reset({ email: storedEmail });
  }, [reset]);

  let tenantName = localStorage.getItem("tenantName")
    ? localStorage.getItem("tenantName")
    : null;

  let contactEmail = localStorage.getItem("contactEmail")
    ? localStorage.getItem("contactEmail")
    : null;

  let firstName = localStorage.getItem("firstName")
    ? localStorage.getItem("firstName")
    : null;

  let lastName = localStorage.getItem("lastName")
    ? localStorage.getItem("lastName")
    : null;

  const [changePassword] = useMutation(CHANGE_PASSWORD_MUTATION);
  const [changeEmail] = useMutation(CHANGE_EMAIL_MUTATION);

  /*##########################################################################
  ## Const : onSubmitPassword
  ## Description : Complete the sumbit functionality of password change 
  ## Author : SF
  ## Date: : 2025/08/04
  ##########################################################################*/

  const onSubmitPassword = async formData => {

    if (formData.newPassword.toString().trim() == "")
    {
      setErrorMsg({ ...errorMsg, newPassword: "Password cannot be blank." });
      return;
    } 
    if (formData.confirmNewPassword.toString().trim() == "")
    {
      setErrorMsg({ ...errorMsg, confirmNewPassword: "Repeat Password cannot be blank." });
      return;
    }
    if (formData.newPassword.toString().trim() !== 
      formData.confirmNewPassword.toString().trim()
    )
    {
      setErrorMsg({ ...errorMsg, samePasswords: "New Password and Repeat New Password must be the same!" });
      return;
    }

    if (formData.newPassword === formData.confirmNewPassword) {
      const { data, error } = await changePassword({
        variables: {
          password: formData.newPassword,
          email: email,
        },
      });
      if (error) {
        console.log("Error", error, data);
        setErrorMsg(error.graphQLErrors[0].message);
      } else {
        setAlertMsg({
          title: "Success",
          msg: "New Password was changed successfully.",
        });
      }
    };
  };

  /*##########################################################################
  ## Const : onSubmitEmail
  ## Description : Complete the sumbit functionality of email change 
  ## Author : SF
  ## Date: : 2025/08/04
  ##########################################################################*/

  const onSubmitEmail = async frmData => {

    if (frmData.email.toString().trim() == "")
    {
      setErrorMsg({ ...errorMsg, email: "Email cannot be blank." });
      return;
    }     

    if (frmData.email.toString().trim() === 
        originalEmail.toString().trim()
    )
    {
      navigate(`${project_url}/applicant/dashboard`);
      return
    };        

    if (frmData.email && frmData.email !== originalEmail){
      const { data, error } = await changeEmail({
        variables: {
          tenantName: tenantName,
          contactEmail: contactEmail,
          firstName: firstName,
          lastName: lastName,
          newEmail: frmData.email,
          email: originalEmail,
          userType: "Applicant"
        },
      });
      
      if (error && error.graphQLErrors) {
        if (error.graphQLErrors[0].message.includes("Email already exists!")) {
          setAlertMsg({
            title: "Email Validation",
            msg: "This email address cannot be saved, because it is already used by another resource.",
          });
        }
        else
        {
          console.log("Error", error, data);
          setErrorMsg(error.graphQLErrors[0].message);
        }
      } else {
        localStorage.setItem("email", frmData.email);
        setEmail(frmData.email);               // update displayed email
        setOriginalEmail(frmData.email);       // update original
        setAlertMsg({
          title: "Success",
          msg: "New Email was changed successfully.",
        });
      }
    };
  };

  const passwordChange = event => {
    setErrorMsg({ ...errorMsg, samePasswords: "" });
  };

  const retypePasswordChange = event => {
    setErrorMsg({ ...errorMsg, samePasswords: "" });
  };

  const emailChange = event => {
    setErrorMsg({ ...errorMsg, email: "" });
  };

  const handleProfileTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div className={classes.root}>
      <Header breadcrumbs={[{ label: "Profile", link: null }]} />
      <div className={classes.container}>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body1" style={{ marginBottom: 10 }}>
            Profile
          </Typography>
          <Divider />
        <Grid container alignItems="center">
          <Grid item xs={12}>
            <Tabs
              value={selectedTab}
              onChange={handleProfileTabChange}
              variant="scrollable"
              scrollButtons="auto"
              className={classes.profileTabs}
            >
              {["Reset Password", "User Profile"].map((item, index) => (
                <Tab
                  className={classes.tabs}
                  sx={{
                    borderRadius: "4px",
                    fontSize: "16px",
                    fontWeight: 600,
                    minWidth: "160px",
                  }}
                  key={index}
                  label={item}
                />
              ))}
            </Tabs>
          </Grid>
        </Grid>
        {selectedTab == 0 && (
          <form onSubmit={handleSubmit(onSubmitPassword)} autoComplete="off">
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>              
                <TextField
                  autoComplete="new-password"
                  className={classes.textFieldStyle}
                  required
                  fullWidth
                  label="New Password"
                  margin="normal"
                  name="newPassword"
                  type={showPassword ? "text" : "password"} 
                  variant="outlined"
                  id="newPassword"
                  InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  inputProps={{
                    readOnly: true,
                    onFocus: e => e.target.removeAttribute('readOnly'),                    
                  }}
                  {...register("newPassword", { 
                    required: true,
                    pattern: /^[A-Za-z0-9]{6,}$/i,
                  })}
                  onChange={passwordChange}
                />
                {errors.newPassword && errors.newPassword.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Password cannot be blank.
                  </FormHelperText>
                )}              
                {errors.newPassword && 
                  errors.newPassword.type === "pattern" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Enter at least 6 characters and numbers, with no special characters
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                <TextField
                  autoComplete="new-password"
                  className={classes.textFieldStyle}
                  fullWidth
                  required
                  label="Repeat New Password"
                  margin="normal"
                  name="confirmNewPassword"
                  type={showRepeatPassword ? "text" : "password"} 
                  variant="outlined"
                  id="confirmNewPassword"
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleRepeatPassword}
                            edge="end"
                          >
                            {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                  }}
                  inputProps={{
                    readOnly: true,
                    onFocus: e => e.target.removeAttribute('readOnly'),
                    
                  }}                  
                  {...register("confirmNewPassword", { 
                    required: true,
                    pattern: /^[A-Za-z0-9]{6,}$/i,
                  })}
                  onChange={retypePasswordChange}
                />
                {errors.confirmNewPassword && errors.confirmNewPassword.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Repeat Password cannot be blank.
                  </FormHelperText>
                )}
                {errors.confirmNewPassword && 
                  errors.confirmNewPassword.type === "pattern" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Enter at least 6 characters and numbers, with no special characters
                  </FormHelperText>
                )}
                {errorMsg.samePasswords && (
                  <FormHelperText className={classes.errorStyle} error>
                    New Password and Repeat New Password must be the same
                  </FormHelperText>
                )}              
              </Grid>
            </Grid>          
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"                
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/applicant/dashboard`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
        )}
        {selectedTab == 1 && (
          <form onSubmit={handleSubmit(onSubmitEmail)} autoComplete="off">
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>              
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Email address cannot be blank.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Enter a correctly-formed email like myname@xyz.com"
                    }
                  }}
                  render={({ field }) => (
                    <TextField
                      autoComplete="new-email"
                      className={classes.textFieldStyle}
                      fullWidth
                      label="Email"
                      margin="normal"
                      variant="outlined"
                      id="email"
                      value={email}
                      onChange={(e) => {
                        field.onChange(e);
                        setEmail(e.target.value);
                        emailChange(e);
                      }}
                    />
                  )}
                />
                {errors.email && errors.email.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Email address cannot be blank.
                  </FormHelperText>
                )}
                {errors.email && errors.email.type === "pattern" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Enter a correctly-formed email like myname@xyz.com
                  </FormHelperText>
                )}
              </Grid>
            </Grid>                    
            <Box pt={19} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"                
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/applicant/dashboard`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
        )}
        {alertMsg.msg && (
          <AlertDialog
            title={alertMsg.title}
            contentMsg={alertMsg.msg}
            closeDialog={() => {
              setAlertMsg([]);
              alertMsg.title === "Success" && navigate(`${project_url}/applicant/dashboard`);
              alertMsg.title === "Email Validation" && setEmail(originalEmail);
            }}
          />
        )}
        </Box>
      </div>
    </div>
  );
};
export default ApplicantProfile;
